import { type ComponentType, useEffect } from "react";

import { useViewportInfoContext } from "@/src/contexts";
import { useQueryClientCustom } from "@/src/query-client-overrides";
import type { IComponent } from "@Components/Component";
import { defaultAttributes } from "@Components/Component";
import ImageLoader from "@Components/ImageLoader";
import type { ILink } from "@Components/Link";
import { CashbackDetails } from "@Routes/CashbackLinks";

import type { INavigationModalActions } from "../common/NavigationModal";
import { TransitionLink } from "../common/Transition";
import type { ICashbackAdBanner } from "./CashbackCommonInterfaces";

import * as css from "./CashbackWithdrawSuccessPage.module.css";

export interface ICashbackWithdrawSuccessPage extends INavigationModalActions<ICashbackAdBanner>, IComponent {
    link: ILink;
}

export const CashbackWithdrawSuccessPage: ComponentType<ICashbackWithdrawSuccessPage> = (props) => {
    const banner = props.fieldValues?.banner || {};
    const { message, title } = props.fieldValues?.userCommunicationTemplate || {};
    const { isMobile, isTablet } = useViewportInfoContext();
    const queryClient = useQueryClientCustom();

    useEffect(() => {
        queryClient.refetchQueries({
            queryKey: [CashbackDetails, "cashbackDashboard"],
        });
    }, [queryClient]);
    const imageUrl =
        isMobile && banner.imageUrlMobile
            ? banner.imageUrlMobile
            : isTablet && banner.imageUrlTablet
              ? banner.imageUrlTablet
              : banner.imageUrlDesktop
                ? banner.imageUrlDesktop
                : "";

    return (
        <div {...defaultAttributes(props, css.cashbackWithdrawSuccessPageComponent)}>
            <div className={css.innerContent}>
                <h1 className={css.standardTitle}>{title}</h1>
                {message && <p className={css.description} dangerouslySetInnerHTML={{ __html: message }} />}
            </div>
            {imageUrl && <ImageLoader src={imageUrl} />}
            {banner && banner.link && (
                <TransitionLink
                    {...props.link}
                    navigateUrl={banner.link.navigateUrl}
                    className={css.linkContainer}
                />
            )}
        </div>
    );
};
